module.exports = __webpack_public_path__ + "img/act-of-emotion-2.0824b665.jpg";